import AppointmentStatus from '@/entities/AppointmentStatus.ts';
import type { ConversationKind } from '@/api/conversations/types/index.ts';

export { default as AppointmentStatus } from '@/entities/AppointmentStatus.ts';

export interface Message {
    id: number;
    conversationId: number;
    conversationKind: ConversationKind;
    legacySmsConversationId?: number | null;
    communicationId?: number | null;
    text: string | null;
    isIncoming: boolean;
    senderIsAuthUser: boolean;
    senderName: string;
    createdAt: string;
    time?: string;
    attachments: MessageAttachment[];
    appointmentId?: number | null;
    appointment?: AppointmentStatus | null;
    status: string | null;
    errorCode: string | null;
}

export const ATTACHMENT_MIME_TYPES = {
    JPEG: 'image/jpeg',
    GIF: 'image/gif',
    PNG: 'image/png',
    PDF: 'application/pdf',
} as const;

export const isImageAttachment = (mimeType: string): boolean =>
    mimeType === ATTACHMENT_MIME_TYPES.JPEG ||
    mimeType === ATTACHMENT_MIME_TYPES.GIF ||
    mimeType === ATTACHMENT_MIME_TYPES.PNG;

export interface MessageAttachment {
    id: number;
    url: string;
    filename: string;
    mimeType: string;
}

export enum ConversationState {
    ACTIVE = 'active',
    ARCHIVED = 'archived',
    ALL = 'all',
}

export interface ConversationListFilters {
    isIntelligentFilterEnabled: boolean;
    conversationState: ConversationState;
}

export type Attachment = { file: File; preview: string };
